import React, { useEffect, useState } from "react";
import UserWrapper from "../../../../layout/userwrapper/UserWrapper";
import {
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import styles from "../../../../styles/pages/user/content-buyer-searchresult.module.scss";
import Search01 from "../../../../public/assets/images/s01.jpg";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Magnifying from "../../../../public/assets/images/icon-magnifying.svg";
import BlueeditIcon from "../../../../public/assets/icons/BlueeditIcon";
import {
  getAbsoluteImageURI,
  getUtcDate,
  getUtcTime,
} from "../../../../lib/functions/utils.lib";
import { useInfiniteFetch } from "../../../../hooks/api/useInfiniteFetch";
import { useAppSelector } from "../../../../hooks/useAppSelector";
import InfiniteScroll from "react-infinite-scroll-component";
import { Fragment } from "react";

export default function ContentbuyerSearchResult() {
  const { query } = useAppSelector((s) => s.searchQuerySlice);

  const [previousData, setPreviousData] = useState(null);
  const [searchData, setSearchData] = useState("");

  const { data, fetchNextPage, hasNextPage, refetch, isLoading } =
    useInfiniteFetch(
      ["content-buyer-search", query],
      `buyer/videos?search=${query}`
    );

  useEffect(() => {
    if (data) {
      setPreviousData(data);
      setSearchData(query);
    }
  }, [data]);
  console.warn(data);
  return (
    <UserWrapper headerPurchaseBtn={true} footerChatBtn={true}>
      <Paper elevation={0} className={styles.paperResult}>
        <Box className={styles.searchBodymid}>
          {data?.pages?.[0]?.data?.total ? (
            <>
              <Stack
                direction={"row"}
                alignItems={"center"}
                flexWrap={"wrap"}
                className={styles.showResult}
              >
                <Typography variant="body1">
                  Search results for “{query}”
                </Typography>
                <Typography variant="overlie">
                  {data?.pages?.[0]?.data?.total
                    ? data?.pages?.[0]?.data?.total
                    : 0}{" "}
                  results
                </Typography>
              </Stack>
              <Paper elevation={0} className={styles.paperSrchresult}>
                <InfiniteScroll
                  dataLength={
                    data?.pages?.[0]?.data?.total
                      ? data?.pages?.[0]?.data?.total
                      : 0
                  }
                  next={fetchNextPage}
                  height={`calc(100vh - 159px)`}
                  hasMore={hasNextPage}
                  loader={<h4>Loading... </h4>}
                  className={styles.scrollbodyPaper}
                >
                  {data?.pages?.map((group, groupIndex) => (
                    <Fragment key={groupIndex}>
                      {group?.data?.data.map((item, index) => (
                        <Stack
                          direction={"row"}
                          alignItems={"flex-start"}
                          flexWrap={"wrap"}
                          className={styles.searchItem}
                          key={index}
                        >
                          <figure className={styles.mediaLeft}>
                            <img
                              src={getAbsoluteImageURI(item?.thumbnail)}
                              alt=""
                            />
                          </figure>
                          <Box className={styles.mediaRight}>
                            <List disablePadding>
                              <ListItem disablePadding>
                                <Typography variant="caption">VSID:</Typography>
                                <Typography variant="body1">
                                  #{item?.id}
                                </Typography>
                              </ListItem>
                              <ListItem disablePadding>
                                <Typography variant="caption">
                                  Purchase Request Date:
                                </Typography>
                                <Typography variant="body1">
                                  {item?.submissionDate}
                                </Typography>
                              </ListItem>
                              <ListItem
                                className={styles.submitterName}
                                disablePadding
                              >
                                <Typography variant="caption">
                                  Owner Name:
                                </Typography>
                                <Typography variant="body1">
                                  {`${item?.first_name} ${item?.last_name}`}
                                </Typography>
                              </ListItem>
                              <ListItem disablePadding>
                                <Typography variant="caption">
                                  Email Address:
                                </Typography>
                                <Typography variant="body1">
                                  {item?.email}
                                </Typography>
                              </ListItem>
                            </List>
                            <Box>
                              {item?.purchase_request_status ? (
                                <Stack
                                  direction={"row"}
                                  alignItems={"center"}
                                  flexWrap={"wrap"}
                                  className={`${
                                    item?.purchase_request_status === 1
                                      ? `${styles.bgGreen} `
                                      : item?.purchase_request_status === 0
                                      ? `${styles.bgLightOrng} `
                                      : item?.purchase_request_status === 2
                                      ? `${styles.bgLightred}`
                                      : ""
                                  } ${styles.srchStatus} ${
                                    styles.purchaseRequestBar
                                  }`}
                                >
                                  <Typography variant="body2">
                                    Purchase request:
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    className={styles.pendingstatus}
                                  >
                                    {item?.purchase_request_status === 1
                                      ? "Approved"
                                      : item?.purchase_request_status === 0
                                      ? "Pending"
                                      : item?.purchase_request_status === 2
                                      ? "Reject"
                                      : ""}
                                  </Typography>
                                </Stack>
                              ) : (
                                ""
                              )}
                              {item?.purchase_request_status === 1 ? (
                                <>
                                  <Stack
                                    direction={"row"}
                                    alignItems={"center"}
                                    flexWrap={"wrap"}
                                    className={`${styles.srchStatus} ${styles.bgLightsky}`}
                                  >
                                    <Typography variant="body2">
                                      Purchased?
                                    </Typography>
                                    <Typography variant="caption">
                                      {item?.purchase_request_purchased
                                        ? "Yes"
                                        : "No"}
                                    </Typography>
                                  </Stack>
                                </>
                              ) : null}
                            </Box>
                          </Box>
                          <Button className={styles.editresultBtn}>
                            <BlueeditIcon />
                          </Button>
                        </Stack>
                      ))}
                    </Fragment>
                  ))}
                </InfiniteScroll>
              </Paper>
            </>
          ) : (
            <Paper elevation={0} className={styles.nodataFound}>
              <figure>
                <img src={Magnifying} alt="" />
              </figure>
              <Typography variant="body1">
                We couldn't find any matching videos for{" "}
                <strong>{query}</strong>.
              </Typography>
            </Paper>
          )}
        </Box>
      </Paper>
    </UserWrapper>
  );
}
